module.exports = __webpack_public_path__ + "img/arqu-cabc-01.2b808527.jpg";